<template>
  <div
    class="viewcontent"
    v-if="
      translations.activity &&
        translations.account &&
        translations.errors &&
        translations.select
    "
  >
    <form class="row mx-3" @submit.prevent="processActivity">
      <Alert type="warning" :list="errors.activity"/>
      <Alert type="info" :message="translations.errors.finished_activity" v-if="checkDate"/>
      <div class="col-sm-6 col-xs-12">
        <div v-if="eventLanguages">
          <div v-for="(item, index) in eventLanguages" :key="index">
            <label
              for="full_name"
              class="form-label w-100 my-3"
              v-for="(title, titleindex) in checkTitleLanguage(item)"
              :key="titleindex"
              ><span class="key"> [{{ item }}] </span>
              {{ translations.activity.form_title }}
              <span class="text-danger">*</span>
              <input
                type="text"
                id="full_name"
                name="full_name"
                :placeholder="translations.placeholders.activity_title"
                class="form-control"
                v-model="title.text"
                :disabled="checkDate"
                required
              />
            </label>

            <label
              for="description"
              class="form-label w-100 my-3"
              v-for="(description,
              descriptionindex) in checkDescriptionLanguage(item)"
              :key="descriptionindex"
              ><span class="key"> [{{ item }}] </span>
              {{ translations.activity.form_description }}
              <textarea
                rows="5"
                class="form-control"
                id="description"
                :placeholder="translations.placeholders.activity_description"
                name="description"
                v-model="description.text"
                :disabled="checkDate"
                required
              >
              </textarea>
            </label>
          </div>
        </div>

        <label for="pictures" class="form-label w-100 my-3"
          >{{ translations.activity.form_pictures }} (800x600px)
          <input
            type="file"
            accept=".jpg,.jpeg"
            id="pictures"
            name="pictures"
            :disabled="checkDate"
            class="form-control"
            @change="onPictureChange"
            multiple="multiple"
          />
        </label>

        <div class="col-12 p-4" v-if="activity.edit_picture">
          <div class="col-12" v-if="preview">
            <img
              class="img-fluid img-thumbnail preview"
              :src="preview"
              :alt="activity.title"
            />
          </div>
        </div>
        <div class="col-12 p-4" v-else-if="Array.isArray(activity.pictures)">
          <div class="col-12">
            <img
              v-for="(item, index) in activity.pictures"
              :key="index"
              class="img-fluid img-thumbnail preview"
              :src="files + item"
              :alt="activity.title"
            />
          </div>
        </div>

        <label
          class="form-check-label w-100 my-2 form-check "
          for="ods"
          v-if="checkType == 2"
        >
          {{ translations.activity.form_ods }}
          <div
            class="form-check-label item"
            v-for="(item, index) in ods"
            :key="index"
            name="ods"
          >
            <label>
              <input
                class="form-check-input"
                type="checkbox"
                :disabled="checkDate"
                :value="item.id"
                v-model="activity.ods"
              />
              {{ item.title }}</label
            >
          </div>
        </label>

        <label
          class="form-check-label w-100 my-2 form-check "
          for="accessibility"
          v-if="checkType == 1 || checkType == 2"
        >
          {{ translations.activity.form_accessibility }}
          <div class="accessibilitycont">
            <div
              :class="'accesibilityitem ' + checkSelected(item.id)"
              v-for="(item, index) in accessibility"
              :key="index"
              name="accessibility"
            >
              <label>
                <input
                  class="form-check-input icon"
                  type="checkbox"
                  :disabled="checkDate"
                  :value="item.id"
                  v-model="activity.accessibility"
                />
                <img
                  :src="files + item.picture"
                  :alt="item.title"
                  :class="'itemicon '"
                />
              </label>
            </div>
          </div>
        </label>
      </div>

      <div class="col-sm-6 col-xs-12">
        <label for="date" class="form-label w-100 my-3"
          >{{ translations.activity.form_day }}
          <span class="text-danger">*</span>
          <input
            class="form-control"
            type="date"
            :disabled="checkDate"
            id="date"
            v-model="activity.day"
            :min="eventDays.date_start"
            :max="eventDays.date_end"
          />
          <!-- :disabled="eventDays.date_end ? false : true" -->
        </label>
        <label for="time" class="form-label w-50 my-3"
          >{{ translations.activity.form_time }}
          <span class="text-danger">*</span>
          <input
            class="form-control"
            type="time"
            :disabled="checkDate"
            id="time"
            v-model="activity.time"
          />
        </label>
        <label for="duration" class="form-label w-50 my-3"
          >{{ translations.activity.form_duration }} (h)<span
            class="text-danger"
            >*</span
          >
          <input
            class="form-control"
            type="number"
            id="duration"
            min="1"
            max="6"
            :disabled="checkDate"
            :placeholder="translations.placeholders.activity_duration"
            v-model="activity.duration"
          />
        </label>

        <label for="price" class="form-label w-100 my-3" v-if="checkType == 2"
          >{{ translations.activity.form_price }}
          <div v-if="checkDisabled" class="disabledmsg">
            {{ translations.errors.no_available }}

            <span class="disabledlink" @click="linkTo()">
              {{ translations.account.title_plan }}</span
            >
          </div>
          <input
            type="number"
            id="price"
            min="0"
            name="price"
            :class="disabledStyle"
            class="form-control"
            v-model="activity.price"
            :disabled="checkDisabled || checkDate"
          />
        </label>
        <label for="tickets" class="form-label w-100 my-3" v-if="checkType == 2"
          >{{ translations.activity.form_tickets_url }}
          <div v-if="checkDisabled" class="disabledmsg">
            {{ translations.errors.no_available }}

            <span class="disabledlink" @click="linkTo()">
              {{ translations.account.title_plan }}</span
            >
          </div>
          <input
            class="form-control"
            type="text"
            id="tickets"
            :disabled="checkDisabled || checkDate"
            :class="disabledStyle"
            v-model="activity.tickets_url"
          />
        </label>
        <label for="hashtags" class="form-label w-100 my-3">
          {{ translations.activity.form_hashtags }}
          <input
            onkeydown="return /[a-z0-9\s]/i.test(event.key)"
            class="form-control"
            type="text"
            id="hashtags"
            :placeholder="translations.placeholders.activity_hashtags"
            v-model="activity.hashtags"
            maxlength="50"
            :disabled="checkDate"
          />
        </label>
        <label for="categories" class="form-label w-100 my-3"
          >{{ translations.activity.form_categories }}
          <SelectMultiple
            v-model="activity.categories"
            :title="translations.placeholders.activity_categories"
            :values="categories"
            name="categories"
            :disabled="checkDate"
            class="selector"
            :filter="true"
          />
        </label>

        <label for="editor" class="form-label w-100 my-3" v-if="checkType == 2"
          >{{ translations.activity.form_editor }}
          <input
            type="email"
            id="editor"
            name="editor"
            :disabled="checkDate"
            class="form-control"
            v-model="activity.editor"
          />
        </label>
        <label
          for="type"
          class="form-label w-100 my-3"
          v-if="checkType == 2 && equipments.length > 0 && checkEditor"
          >{{ translations.activity.form_equipment }}
          <select
            class="form-select"
            id="type"
            :disabled="checkDate"
            name="type"
            v-model="activity.equipment_id"
          >
            <option value="">{{
              translations.select.default_equipment
            }}</option>
            <option
              v-for="(item, index) in equipments"
              :value="item.id"
              :key="index"
            >
              {{ defineTitle(item.title) }}
            </option>
          </select>
        </label>

        <label for="location" class="form-label w-100 my-3" v-if="checkEditor"
          >{{ translations.activity.form_location }}
          <span class="text-danger">*</span>

          <ComponentWithMap
            @updateMap="updateMap"
            :type="
              (activity.equipment_id && checkType == 2) || checkDate
                ? 'read'
                : 'edit'
            "
            :getmarkers="formatMarkers"
            :getaddress="getLocation"
            name="location"
            :key="activity.location"
          />
        </label>
      </div>

      <div class="col-12 pt-2" v-if="translations.buttons">
        <button class="btn btn-danger mx-2" type="button" @click="cancel()">
          {{ translations.buttons.btn_exit }}
        </button>
        <button
          class="btn btn-success mx-2"
          type="button"
          @click="showBudget()"
          v-if="checkType == 2"
        >
          {{ translations.buttons.btn_budget }}
        </button>

        <button class="btn btn-primary mx-2" type="submit">
          {{ translations.buttons.btn_save }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  import SelectMultiple from '@/components/SelectMultiple.vue'
  import ComponentWithMap from '@/components/ComponentWithMap.vue'
  import Alert from '@/components/atoms/Alert.vue'
  import router from '../router'

  export default {
    name: 'ToolActivityEdit',
    components: {
      SelectMultiple,
      ComponentWithMap,
      Alert,
    },
    data() {
      return {
        input: {
          title: [],
          description: [],
        },
        preview: false,
      }
    },
    computed: {
      ...mapState([
        'errors',
        'eventLanguages',
        'activityID',
        'activity',
        'files',
        'eventDays',
        'categories',
        'editors',
        'event',
        'translations',
        'ods',
        'accessibility',
        'equipments',
        'languageSelected',
        'editor_activity',
      ]),
      checkDisabled() {
        let result = true
        if (this.event.premium > 0) {
          result = false
        }
        return result
      },
      checkEditor() {
        return this.editor_activity == 'get'
      },
      checkDate() {
        let d1 = new Date()
        let d2 = new Date(this.activity.day + ' ' + this.activity.time)
        d2.setHours(d2.getHours() + this.activity.duration)
        return d1 > d2
      },
      disabledStyle() {
        let clas = ''
        if (this.checkDisabled) {
          clas = 'bg-disabled'
        }
        return clas
      },
      checkType() {
        return this.event.premium
      },

      formatMarkers() {
        let result = null
        if (this.activity.equipment_id && this.checkType == 2) {
          let equipment = this.equipments.find(
            (item) => item.id === this.activity.equipment_id
          )
          if (equipment) {
            result = {
              position: {
                lat: parseFloat(equipment.location_lat),
                lng: parseFloat(equipment.location_lon),
              },
            }
            this.activity.location_lat = parseFloat(equipment.location_lat)
            this.activity.location_lon = parseFloat(equipment.location_lon)
          }
        } else {
          if (this.activity.location_lat && this.activity.location_lon) {
            result = {
              position: {
                lat: this.activity.location_lat,
                lng: this.activity.location_lon,
              },
            }
          }
        }

        return result
      },
      getLocation() {
        let result = null
        if (this.activity.equipment_id && this.checkType == 2) {
          let equipment = this.equipments.find(
            (item) => item.id === this.activity.equipment_id
          )
          if (equipment) {
            result = equipment.location
            this.activity.location = equipment.location
          }
        } else {
          result = this.activity.location
        }

        return result
      },
    },
    watch: {
      'errors.activity.length': function () {
        if (this.errors.activity.length > 0) {
          this.$nextTick(() => {
            this.$el.querySelector('.alert').scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
          })
        }
      }
    },
    methods: {
      ...mapActions([
        'resetError',
        'addActivity',
        'changeToolSelected',
        'getActivity',
        'editActivity',
        'saveFinishedActivity',
      ]),
      linkTo() {
        this.changeToolSelected(null)
        router.push('/account')
      },
      async showBudget() {
        await this.saveFinishedActivity(this.checkDate)
        this.changeToolSelected(20)
      },
      processActivity() {
        this.activity.title = JSON.stringify(this.input.title)
        this.activity.description = JSON.stringify(this.input.description)
        if (this.activity.location) {
          this.editActivity(this.activity)
        }
      },
      onPictureChange(e) {
        let file = e.target.files
        this.activity.pictures = file
        this.activity.edit_picture = true

        if (e.target.files.length !== 0) {
          this.preview = URL.createObjectURL(file[0])
        }
      },
      checkTitleLanguage(language) {
        return this.input.title.filter((item) => item.key == language)
      },
      checkDescriptionLanguage(language) {
        return this.input.description.filter((item) => item.key == language)
      },
      cancel() {
        this.changeToolSelected(null)
      },
      async setInputs() {
        if (this.activity.title && this.input.title.length <= 0) {
          this.input = {
            title: this.activity.title,
            description: this.activity.description,
          }

          if (this.input.title && this.input.title.length <= 0) {
            await this.generateInputs()
          }
        }
      },
      generateInputs() {
        if (this.eventLanguages && this.eventLanguages.length > 0) {
          for (let index = 0; index < this.eventLanguages.length; index++) {
            let found = this.input.title.some((el) => {
              return el.key === this.eventLanguages[index]
            })
            if (!found) {
              this.input.title.push({
                key: this.eventLanguages[index],
                text: '',
              })
              this.input.description.push({
                key: this.eventLanguages[index],
                text: '',
              })
            }
          }
        } else {
          this.input.title = []
          this.input.description = []
        }
      },
      updateMap(item) {
        this.activity.location_lat = item.coords.position.lat
        this.activity.location_lon = item.coords.position.lng
        this.activity.location = item.address
      },
      checkSelected(id) {
        let result = ''
        if (
          this.activity.accessibility &&
          this.activity.accessibility.find((item) => item == id)
        ) {
          result = 'iconselected'
        }

        return result
      },
      defineTitle(title) {
        let text = ''

        if (title) {
          let result = title.find((x) => x.key === this.languageSelected)
          text = result && result.text ? result.text : title[0].text
        }

        return text
      },
    },
    async created() {
      await this.getActivity(this.activityID)
      await this.setInputs()
      await this.generateInputs()
    },
    beforeUnmount() {
      this.resetError()
    },
  }
</script>

<style scoped>
  .key {
    text-transform: uppercase;
    font-weight: bold;
  }
  .bg-disabled {
    background-color: #fffac0;
  }
  .disabledmsg {
    font-size: 12px;
  }
  .disabledlink:hover {
    color: #ffc107;
  }
  .form-check {
    padding-left: initial;
  }
  .form-check .item {
    text-align: left;
    padding-left: 1.5rem;
  }
  .form-check .icon {
    height: 0;
    width: 0;
    padding-left: 0;
    border: 0;
  }
  .form-check .icon [type='checkbox'] {
    width: 0;
    height: 0;
  }
  .itemicon {
    height: 100%;
  }
  .iconselected {
    filter: invert(62%) sepia(24%) saturate(950%) hue-rotate(100deg)
      brightness(96%) contrast(87%);
    border-color: #2b9348;
  }
  .disabledlink {
    font-weight: bold;
  }
  .preview {
    max-height: 200px;
  }
  .accessibilitycont {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .accesibilityitem,
  .accesibilityitem label {
    height: 45px;
  }
  .accesibilityitem label {
    border: 1px solid;
    border-radius: 10px;
  }
</style>
